import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { setHoveredFeature } from "../../actions/ui";
import {
  selectHoveredFeature,
  selectBasemap,
  selectSidebarIsOpen,
  selectSidebarScrollup,
  selectAllRegionContent,
  selectGeoJSON,
} from "../../reducers";
import PropTypes from "prop-types";
import { setSidebarIsOpen, setZoomToNsw } from "../../actions/ui";
import styles from "./sidebar.module.scss";
import { colors } from "../../modules/theme";
import { ChevronDoubleLeft, ChevronDoubleRight } from "../icons/icons";

const Sidebar = (props) => {
  const {
    sidebarIsOpen,
    setSidebarIsOpen,
    sideBarScroll,
    allRegionContent,
    hoveredFeature,
    setHoveredFeature,
    geojson,
  } = props;
  //eslint-disable-next-line
  const [_viewingProjectIndex, setViewingProjectIndex] = useState(0);

  const scrollContainer = useRef(null);

  // Scroll to the top of the sidebar when something is selected
  useEffect(() => {
    scrollContainer.current.scrollTop = 0;
  }, [sideBarScroll]);

  const title = "Regions";

  return (
    <div
      className={`${styles.sidebarContainer} ${
        sidebarIsOpen ? styles.sidebarOpen : styles.sidebarClosed
      }`}
      onClick={() => {
        setSidebarIsOpen(!sidebarIsOpen);
      }}
      id="goregional-sidebar"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={styles.projectsSidebar}
        ref={scrollContainer}
        style={{
          backgroundColor: "#fff",
        }}
      >
        <h3
          className={styles.sidebarSectionHeader}
          style={{
            color: colors.sectionHeader,
            marginTop: 0,
          }}
        >
          {title}
        </h3>
        {allRegionContent && (
          <div className={styles.allRegions}>
            <h4>
              Find holiday activities by selecting a region from the list below
              or from the map:
            </h4>
            <p>Links will open in a new tab</p>
            <ul className={styles.allRegionsList}>
              {Object.entries(allRegionContent).map((r, key) => {
                const regionContent = allRegionContent
                  ? allRegionContent[r[0]]
                  : null;

                return (
                  <li key={key + r[0]} tabIndex={sidebarIsOpen ? 0 : -1}>
                    <a
                      href={regionContent.link}
                      target="_blank"
                      onMouseEnter={() => {
                        const f = geojson.features.find(
                          (d) => d.properties["REGION"] === r[0]
                        );
                        setHoveredFeature(f);
                      }}
                    >
                      {r[0]}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
      <div
        className={styles.sidebarHandle}
        style={{ backgroundColor: "rbga(255, 255, 255, 0.5)" }}
      >
        <button className={styles.sidebarHandleButton}>
          {sidebarIsOpen ? (
            <ChevronDoubleLeft color="#000" width="14px" height="14px" />
          ) : (
            <ChevronDoubleRight color="#000" width="14px" height="14px" />
          )}
        </button>
      </div>
    </div>
  );
};

const featureShape = {
  type: PropTypes.string.isRequired,
  geometry: PropTypes.object.isRequired,
  properties: PropTypes.object.isRequired,
};
const mapStateToProps = (s) => ({
  basemap: selectBasemap(s),
  sidebarIsOpen: selectSidebarIsOpen(s),
  sideBarScroll: selectSidebarScrollup(s),
  allRegionContent: selectAllRegionContent(s),
  hoveredFeature: selectHoveredFeature(s),
  geojson: selectGeoJSON(s),
});
const mapDispatchToProps = {
  setSidebarIsOpen,
  setZoomToNsw,
  setHoveredFeature,
};
Sidebar.propTypes = {
  setSidebarIsOpen: PropTypes.func.isRequired,
  sidebarIsOpen: PropTypes.bool,
  sideBarScroll: PropTypes.number,
  allRegionContent: PropTypes.object,
  setZoomToNsw: PropTypes.func.isRequired,
  hoveredFeature: PropTypes.shape(featureShape),
  setHoveredFeature: PropTypes.func.isRequired,
  geojson: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js